const ProfilView = () => import("@views/profile/profile-view.vue");
import SpremembaGesla from "@views/profile/password-change.vue";

export const profilRoutes = [
    {
        component: ProfilView,
        name: "profil_home",
        path: "profil",
        redirect: { name: "sprememba_gesla" },
        children: [
            {
                component: SpremembaGesla,
                name: "sprememba_gesla",
                path: "sprememba-gesla"
            }
        ]
    },
];